var React = require('react');

function Stop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M6 6h12v12H6z","key":1})]);
}

Stop.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Stop;

Stop.default = Stop;
